var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('div',{class:`icon ${_vm.size}`,attrs:{"rounded":_vm.rounded}},[_c('i',{class:`${_vm.type} fa-${_vm.icon}`})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }